<template>
  <v-tooltip bottom v-if="erros.length > 0">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="error"
        dark
        icon
        x-small
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-alert-circle</v-icon>
      </v-btn>
    </template>
    <div>
      <p v-for="(erro, index) in erros" :key="index" class="ma-0 pa-0">- {{ erro }}</p>
    </div>
  </v-tooltip>
</template>

<script>
export default {
  name: "SpanErroInput",
  props: {
    erros: {
      type: Array,
      required: false
    }
  }
}
</script>

<style scoped>
</style>
